import { render, staticRenderFns } from "./customer.select.vue?vue&type=template&id=ee5d1644&scoped=true&"
import script from "./customer.select.vue?vue&type=script&lang=js&"
export * from "./customer.select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5d1644",
  null
  
)

export default component.exports